import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowShuffle = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.115 18.638C15.365 18.392 15.618 18.14 15.879 17.879C16.097 17.661 16.319 17.44 16.543 17.219C14.522 15.434 12.22 14 9 14H8V16H9C11.513 16 13.385 17.132 15.115 18.638Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 16V19L32 15L28 11V14H27C22.586 14 19.895 16.69 17.293 19.293C14.872 21.714 12.586 24 9 24H8V26H9C13.414 26 16.105 23.31 18.707 20.707C21.128 18.286 23.414 16 27 16H28Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 24H27C24.487 24 22.615 22.868 20.885 21.362C20.635 21.608 20.382 21.86 20.121 22.121C19.903 22.339 19.681 22.56 19.457 22.781C21.478 24.566 23.78 26 27 26H28V29L32 25L28 21V24Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgArrowShuffle);
export default ForwardRef;
